<i18n>
  {
    "en": {
      "noCreditCardSupport": "No credit card? You can refer to {method}",
      "otherPaymentMethod": "other payment method"
    },
    "zhHant": {
      "noCreditCardSupport": "沒有信用卡嗎？可以參考{method}喔",
      "otherPaymentMethod": "其他付款方式"
    },
    "ja": {
      "noCreditCardSupport": "クレジットカードがない場合は、{method} を参照してください",
      "otherPaymentMethod": "その他の支払い方法"
    },
    "ko": {
      "noCreditCardSupport": "신용카드가 없으신가요? {method} 를 참조하세요",
      "otherPaymentMethod": "다른 결제 방법"
    }
  }
  </i18n>
<template>
  <v-alert :value="isShow" color="warning" outline>
    <div>
      <i18n path="noCreditCardSupport" tag="div">
        <template v-slot:method>
          <a :href="otherPaymentMethodLink" target="_blank">{{ $t('otherPaymentMethod') }}</a>
        </template>
      </i18n>
    </div>
  </v-alert>
</template>
<script>
export default {
  name: 'NoCreditCardHint',
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    supportGame: {
      type: String,
      default: 'tsum',
    }
  },
  computed: {
    otherPaymentMethodLink() {
      switch (this.$i18n.locale) {
        case 'en':
          return 'https://sites.google.com/view/xrobotmon/en/faq';
        case 'zhHant':
          return 'https://www.tsumtsum.app/zh/%E5%B8%B8%E8%A6%8B%E5%95%8F%E9%A1%8C';
        case 'ja':
          return 'https://sites.google.com/view/xrobotmon/ja/faq#h.gyak0pjofd8u';
        case 'ko':
          return 'https://sites.google.com/view/xrobotmon/en/faq';
        default:
          return 'https://sites.google.com/view/xrobotmon/en/faq';
      }
    }
  }
}
</script>